
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/HeatMap/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["heatmap-demo-en-0","heatmap-demo-en-1"],
  getter: () => import(/* webpackChunkName: "meta__HeatMap__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/HeatMap/index.en.md?type=demo')
};